import { api } from '../api';
import type {
  LabelFieldKey,
  LabelSizeKey,
  LabelTemplate,
  RecipeLabelTemplate,
} from '@/types/label-template';

/**
 * The tenant's label template, and one recipe's resolved view of it (T-1001).
 *
 * Writes replace the whole field list rather than toggling one field: "which
 * fields print" is a single decision, and two admins saving at once should not
 * be able to produce a label neither of them chose.
 */
export const labelTemplateApi = {
  get: () => api.get<LabelTemplate>('/label-templates'),

  /** An omitted `size` leaves the stock alone rather than resetting it (T-1003). */
  update: (fields: LabelFieldKey[], size?: LabelSizeKey) =>
    api.put<LabelTemplate>('/label-templates', size ? { fields, size } : { fields }),

  getForRecipe: (recipeId: number | string) =>
    api.get<RecipeLabelTemplate>(`/label-templates/recipes/${recipeId}`),

  /** An empty list clears the override and returns the recipe to inheriting. */
  updateForRecipe: (recipeId: number | string, fields: LabelFieldKey[]) =>
    api.put<RecipeLabelTemplate>(`/label-templates/recipes/${recipeId}`, { fields }),
};
